import React from 'react';

import MultiSelectFilter from 'components/ReactTable/Filters/MultiSelectFilter';
import CustomerLinkCell from 'components/ReactTable/CellRenderers/CustomerLinkCell';
import AccountLinkCell from 'components/ReactTable/CellRenderers/AccountLinkCell';
import ValidationResultCell from 'components/ReactTable/CellRenderers/ValidationResultCell';

// note: for the sorting to work, the 'accessor' properties below must have the same name as the backend property to be sorted by
const rejectedFormColumnDefs = permissions => [
  {
    Header: 'Customer Id',
    accessor: 'customer',
    Cell: cellInfo => (
      <CustomerLinkCell dataKey="customerDbId" data={ cellInfo.row.original } permissions={ permissions } />
    ),
    className: 'col-15p'
  },
  {
    Header: 'Form Type',
    accessor: 'formTypeDescription',
    Filter: MultiSelectFilter
  },
  {
    Header: 'Workflow',
    accessor: 'workflowStatus',
    Filter: MultiSelectFilter,
    Cell: cellInfo => ((cellInfo.row.original.workflowStatus) ? cellInfo.row.original.workflowStatus : 'N/A')
  },
  {
    Header: 'Account',
    accessor: 'account',
    Cell: cellInfo => (
      <AccountLinkCell dataKey="accountId" data={ cellInfo.row.original } permissions={ permissions } />
    ),
    className: 'col-15p'
  },
  {
    Header: 'Reasons For Rejection',
    id: 'rejections',
    Cell: cellInfo => (
      <ValidationResultCell dataKey="rejections" data={ cellInfo.row.original.validationData } className="reasons-for-rejection-list" />
    ),
    disableFilters: true,
    className: 'col-20p rejections-list'
  },
  {
    Header: 'Warnings / Instructions',
    id: 'warnings',
    Cell: cellInfo => (
      <ValidationResultCell dataKey="warnings" data={ cellInfo.row.original.validationData } className="red-flags-and-recs-list" />
    ),
    disableFilters: true,
    className: 'col-20p warnings-list'
  },
  {
    Header: 'Sign Date',
    accessor: 'signDate',
    disableFilters: true,
    className: 'col-12p5'
  }
];

export default rejectedFormColumnDefs;
